var provider;

var webReturnURL =
  window.location.href.substr(0, window.location.href.indexOf("/", 8)) + "/";
var mobileReturnURL = "https://assets.getcueapp.com/"; // TODO move to config
var getLoginURL = retURL =>
  API_URL +
  "authentication/enterOrg?redirect_uri=" +
  encodeURIComponent(retURL);

var instance = [
  "$q",
  "$injector",
  "$rootScope",
  "$sce",
  function($q, $injector, $rootScope, $sce) {
    // eslint-disable-next-line one-var
    var _token, _userdata, _server;

    var interceptor = {
      debug: 1,

      get server() {
        return _server;
      },
      set server(server) {
        _server = server;
      },

      get userdata() {
        return _userdata;
      },
      set userdata(userdata) {
        _userdata = userdata;
        $rootScope.userdata = userdata;
      },

      get token() {
        return _token;
      },
      set token(token) {
        _token = token;
        if (token !== "NONE") {
          appStorage.setItem("backend.auth.token", token || "");
        }
      },

      logout: function(isExpired) {
        interceptor.token = null;
        interceptor.userdata = null;

        // Selective clear
        Object.keys(appStorage)
          .filter(k => k.indexOf("admin_") !== 0)
          .forEach(k => appStorage.removeItem(k));

        redirectToBackendLogin();
      },

      request: function(config) {
        if (window.BAD) config.url = "http://localhost:12345/asdfsdf"; // TODO remove
        if (!shouldIntercept(config)) {
          // not related to our server;
          return config;
        }

        ensureToken();
        return injectAuthParams(config);
      },
      requestError: function(rejection) {
        console.warn("backend.request.ERROR", rejection);
        return $q.reject(rejection);
      },

      responseError: function(rejection) {
        console.warn("responseError: ", rejection);
        if (rejection.status === 401) {
          console.warn("responseError: got status 401 - redirecting");
          setTimeout(redirectToBackendLogin, 0);
        }
        return $q.reject(rejection);
      },
      response: function(response) {
        console.info("RESPONSE", response);
        // TODO maybe remove this?
        if (
          shouldIntercept(response.config) &&
          !(
            /\/login$/.test(response.config.url) ||
            /\/system-config$/.test(response.config.url)
          ) &&
          response.data &&
          response.data.success === false
        ) {
          console.error(
            "backend.response.ERROR",
            response.data.statusCode,
            response.data.apiErrorType,
            response.data.errorMessage
          );
          // return rejectOrReAuth(response);
        }
        return $q.resolve(response);
      },

      initAuth: function(allowPublic) {
        // TODO maybe do this differently. Did it this way because $location.search()
        // requires some config tweaking to work, apparently
        var qs = window.location.search
          .substr(1)
          .split("&")
          .map(s => s.split("="))
          .reduce((o, p) => {
            o[p[0]] = p[1];
            return o;
          }, {});
        if (qs.access_token) {
          interceptor.token = qs.access_token;
          ensureToken();

          // Clean up url...
          delete qs.access_token;
          window.location.href =
            window.location.origin +
            window.location.pathname +
            (Object.keys(qs).length
              ? "?" +
                Object.keys(qs)
                  .map(k => `${k}=${qs[k]}`)
                  .join("&")
              : "");
        }

        checkLogin().then(() => {
          var $state = $injector.get("$state");
          if (!$state.current.name) {
            $state.go("container");
          }

          const savedRoute = window.appStorage.getItem("__savedRoute");
          if (savedRoute && savedRoute !== "#/login") {
            window.location.hash = savedRoute;
            window.appStorage.removeItem("__savedRoute");
          }
        });
      },

      loadToken: loadToken
    };

    interceptor.server = provider.$apiProvider.server;
    interceptor.debug = provider.$apiProvider.debug;

    window.interceptor = interceptor;
    window.initAuth = interceptor.initAuth;

    return interceptor;

    function shouldIntercept(config) {
      return !config.url.match(/^https?:\/\/[^/]+\/authentication/);
    }

    function injectAuthParams(config) {
      if (!config.params) {
        config.params = {};
      }

      var token = interceptor.token || "";
      if (token !== "NONE") {
        config.headers.Authorization = "Bearer " + token;
        config.headers["X-Selected-Employee-Record"] =
          $rootScope.activePositionRecordCode;
      }

      if (interceptor.debug > 1) {
        console.debug("backend.request", config.url);
      }
      return config;
    }

    function redirectToBackendLogin() {
      if (window.location.hash != "#/login") {
        window.appStorage.setItem("__savedRoute", window.location.hash);
      }
      if (window.isMobileApp) {
        window.location.href = "#/login";
      } else {
        window.location.href = getLoginURL(
          window.isMobileApp ? mobileReturnURL : webReturnURL
        );
      }
      throw new Error(
        "Redirecting to login URL (no actual error - just stopping execution)"
      );
    }

    function loadToken() {
      var token = interceptor.token || appStorage.getItem("backend.auth.token");
      interceptor.token = token;
      return token;
    }

    function ensureToken() {
      // var token = interceptor.token || appStorage.getItem('backend.auth.token');
      var token = loadToken();
      if (!token) {
        return redirectToBackendLogin();
      }
      if (token !== "NONE") {
        appStorage.setItem("backend.auth.token", token);
      }
      // interceptor.token = token;
      return token;
    }

    function checkLogin() {
      if (interceptor.userdata) return;
      ensureToken();
      const utils = $injector.get("$utils")({});
      const http = utils.withRetries($injector.get("$http"), 2, 500);
      return http(
        injectAuthParams({
          url: API_URL + "me",
          method: "GET",
          headers: {}
        })
      ).then(
        function(res) {
          console.info("Got the following user data", res.data);
          interceptor.enterprise = res.data.enterprises[0];
          interceptor.userdata = res.data.user;
          $rootScope.userdata = res.data.user;

          // Keep track of the active position for this user,
          // the default is the first employee record
          const { employeeRecords } = res.data.user;

          $rootScope.activePosition =
            employeeRecords && employeeRecords.length
              ? employeeRecords[0]
              : null;

          $rootScope.auth.confirm();
        },
        function(error) {
          console.error("/me call returned error", error);
          if (!error.status || error.status !== 401) {
            console.error("/me endpoint failed. Redirecting to error page");
            window.location.href = "auth_error.html";
            throw new Error("Stopping execution after redirect");
          }
        }
      );
    }
  }
];

module.exports = [
  "apiProvider",
  function(apiProvider) {
    provider = {
      $apiProvider: apiProvider,
      $get: instance
    };

    return provider;
  }
];



// WEBPACK FOOTER //
// ./src/api/js-data/interceptor.js